import Facebook from 'components/social/facebook'
import Twitter from 'components/social/twitter'
import Linkedin from 'components/social/linkedin'

export default function SocialButton({ socialMedia, link, onClick, title }) {
  return (
    <CustomLink link={link} onClick={onClick} title={title}>
      {socialMedia === 'facebook' ? <Facebook className="h-4" /> : null}
      {socialMedia === 'twitter' ? <Twitter className="h-4" /> : null}
      {socialMedia === 'linkedin' ? <Linkedin className="h-4" /> : null}
    </CustomLink>
  )
}

const CustomLink = ({ link, onClick, title, children }) => (
  <a
    href={link}
    onClick={onClick}
    target="_blank"
    rel="noreferrer noopener"
    title={title}
    className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-orange-200 text-white focus:outline-none focus:ring-2 focus:ring-orange focus:ring-offset-2">
    {children}
  </a>
)
